exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dot-slider-area .dot-wrapper {\n\tposition: relative;\n\tmargin: auto;\n\twidth: 170px;\n    height: 3px;\n    background: #333;\n}\n\n.dot-slider-area .dot-wrapper .dot {\n\twidth: 16px;\n    height: 16px;\n    background: #fff;\n    border: 2px solid #333;\n    border-radius: 50%;\n    position: absolute;\n    left: -10px;\n    top: -6px;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/rubylover/Work/new_vin_photo/site/web/src/app/utilities/dot-slider/dot-slider.component.css
// module id = ../../../../../src/app/utilities/dot-slider/dot-slider.component.css
// module chunks = main